// extracted by mini-css-extract-plugin
export default {"time":"timer_time__AbupA","addButton":"timer_addButton__lXEWI","addButtonIcon":"timer_addButtonIcon__tM1-x"};